import { useState } from "react";
import { Image } from "react-bootstrap";
import { toast } from "react-toastify";
import { useAuth } from "../contexts/AuthContext";
import ConfirmModal from "../components/Modal/ConfirmModal";
import logo from '../assets/hlg logo.webp'
const Header = ({ toggleSidebar }) => {
  const { user, logout } = useAuth();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const confirmLogout = () => {
    setShowLogoutConfirm(false);
    logout();
    toast.info("You've been logged out.");
  };

  return (
    <header className="d-flex align-items-center shadow-sm p-1"
    style={{backgroundColor:"var(--bg-surface)", borderBottom: "1px solid var(--border)"}}>
      <button
        className="btn btn-outline-secondary d-md-none me-3"
        onClick={toggleSidebar}
      >
        <i className="bi bi-list"></i>
      </button>
        <Image className="ms-5" src={logo} alt="hlg logo" height={50} width={60}/>
      <div className="ms-auto d-flex align-items-center">
        <div className="dropdown">
          <button
            className="btn btn-sm btn-outline-secondary dropdown-toggle"
            data-bs-toggle="dropdown"
          >
            <i className="bi bi-person-circle me-1 text-white"></i> {user?.name || "Profile"}
          </button>
          <ul className="dropdown-menu dropdown-menu-end">
            <li>
              <span className="dropdown-item-text small" style={{ color: "var(--text-muted)" }}>
                Signed in as
                <br />
                <strong style={{ color: "var(--text-primary)" }}>{user?.email}</strong>
              </span>
            </li>
            <li><hr className="dropdown-divider" style={{ borderColor: "var(--border)" }} /></li>
            <li>
              <button
                className="dropdown-item text-danger d-flex align-items-center"
                onClick={() => setShowLogoutConfirm(true)}
              >
                <i className="bi bi-box-arrow-right me-2"></i>
                Log out
              </button>
            </li>
          </ul>
        </div>
      </div>

      <ConfirmModal
        show={showLogoutConfirm}
        title="Log out"
        message="Are you sure you want to log out?"
        confirmLabel="Log out"
        cancelLabel="Stay signed in"
        onConfirm={confirmLogout}
        onCancel={() => setShowLogoutConfirm(false)}
      />
    </header>
  );
};

export default Header;
